import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { getAlertClassName } from '../../objects';
import { Icon, IconName, IconSize } from '../icon';
import { Text } from '../text';
import { Title, TitleLevels } from '../title';
import { ToasterPosition } from './ToasterProps';
import { is } from '../../services';
import ToasterContext from './context';
import { hashClass } from '../../helpers';
import { useTrilogyContext } from '../../context';
/**
 * Toaster Component
 * @param children {React.ReactNode} Custom Toast Content
 */
const Toaster = ({ props, ...others }) => {
    const { styled } = useTrilogyContext();
    const { title, position, description, iconName, alert, closable, onClick, className, offset, children } = props;
    const displayed = Boolean(title);
    const positionTop = {
        top: offset || 0,
        position: 'fixed',
    };
    const positionBottom = {
        bottom: offset || 0,
        position: 'fixed',
    };
    const classes = hashClass(styled, clsx('toaster', alert && is(getAlertClassName(alert)), !alert && is('info'), className));
    if (!displayed) {
        return null;
    }
    if (children) {
        return (React.createElement("div", { "data-testid": props.testId, style: (position === ToasterPosition.TOP && positionTop) ||
                (position === ToasterPosition.BOTTOM && positionBottom) ||
                positionTop, onClick: (e) => {
                // eslint-disable-next-line no-unused-expressions
                onClick === null || onClick === void 0 ? void 0 : onClick(e);
                e.stopPropagation();
            }, className: classes, ...others }, children));
    }
    return title ? (React.createElement("div", { "data-testid": props.testId, style: (position === ToasterPosition.TOP && positionTop) ||
            (position === ToasterPosition.BOTTOM && positionBottom) ||
            positionTop, onClick: (e) => {
            // eslint-disable-next-line no-unused-expressions
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
            e.stopPropagation();
        }, className: classes, ...others },
        iconName && React.createElement(Icon, { name: iconName, size: IconSize.SMALL }),
        React.createElement("div", { className: hashClass(styled, clsx('body')) },
            title && React.createElement(Title, { level: TitleLevels.ONE }, title),
            description && React.createElement(Text, null, description)),
        closable && React.createElement(Icon, { onClick: closable, className: 'toaster-close', name: IconName.TIMES, size: IconSize.SMALL }))) : null;
};
/**
 * Toaster provider
 * @param children {React.ReactNode} Custom Toast Content
 * @param duration {number} Duration in MS (Default: 5000)
 * @param offset {number} Offset position margin (Default: 10 dp)
 * @param others
 */
const ToasterProvider = ({ children }) => {
    const [toasterState, setToasterState] = useState(null);
    const [duration, setDuration] = useState(5000);
    const timeRef = useRef(null);
    const showToast = (params) => {
        setToasterState(params);
        params.duration && params.duration > 0 && setDuration(params.duration);
        timeRef.current && clearTimeout(timeRef.current);
    };
    useEffect(() => {
        timeRef.current = setTimeout(() => {
            setToasterState(null);
        }, duration);
    }, [toasterState, toasterState === null || toasterState === void 0 ? void 0 : toasterState.title]);
    return (React.createElement(ToasterContext.Provider, { value: { show: showToast, hide: () => null } },
        children,
        React.createElement(Toaster, { props: {
                title: toasterState === null || toasterState === void 0 ? void 0 : toasterState.title,
                description: toasterState === null || toasterState === void 0 ? void 0 : toasterState.description,
                position: toasterState === null || toasterState === void 0 ? void 0 : toasterState.position,
                iconName: toasterState === null || toasterState === void 0 ? void 0 : toasterState.iconName,
                alert: toasterState === null || toasterState === void 0 ? void 0 : toasterState.alert,
                onClick: toasterState === null || toasterState === void 0 ? void 0 : toasterState.onClick,
                onHide: toasterState === null || toasterState === void 0 ? void 0 : toasterState.onHide,
                closable: toasterState === null || toasterState === void 0 ? void 0 : toasterState.closable,
                offset: toasterState === null || toasterState === void 0 ? void 0 : toasterState.offset,
                testId: toasterState === null || toasterState === void 0 ? void 0 : toasterState.testId,
            } })));
};
export default ToasterProvider;
//# sourceMappingURL=Toaster.js.map